import {Meta} from '@rdcomponents/meta/meta';
import {PageHeaderTitle} from '@rdcomponents/page-header-title/page-header-title';

import {appRoute} from '../../../app-route';
import {BreadCrumbs} from '../../../layout/bread-crumbs/bread-crumbs';
import {Empty} from '../../../layout/empty/empty';
import {NavigationLink} from '../../../layout/navigation-link/navigation-link';
import {PageCard} from '../../../layout/page-card/page-card';
import {PageHeader} from '../../../layout/page-header/page-header';
import {useLocale} from '../../../provider/locale/locale-hook';
import {Locale} from '../../../provider/locale/localization';

import * as styles from './dashboard.scss';

export function DashboardWithoutCompany(): JSX.Element {
    const {getLocalizedString} = useLocale();

    return (
        <>
            <PageCard>
                <Meta title={getLocalizedString('DASHBOARD_PAGE__TITLE')} />
                <BreadCrumbs
                    list={[
                        {
                            path: appRoute.dashboard.path,
                            titleLangKey: 'DASHBOARD_PAGE__TITLE',
                        },
                    ]}
                />
                <PageHeader>
                    <PageHeaderTitle title="DASHBOARD_PAGE__SUB_TITLE" />
                </PageHeader>
            </PageCard>
            <PageCard className={styles.Dashboard_withoutCompanies_pageCardWrapper}>
                <Empty
                    className={styles.Dashboard_withoutCompanies_emptyWrapper}
                    mainText="DASHBOARD_PAGE__WITHOUT_COMPANIES__HEADER"
                    secondaryText="DASHBOARD_PAGE__WITHOUT_COMPANIES__TEXT"
                    secondaryTextValueMap={{
                        sourceLink: (
                            <NavigationLink key="sourceLink" to={appRoute.sources.path}>
                                <Locale stringKey="CATEGORY_NAME__SOURCES" />
                            </NavigationLink>
                        ),
                        myCompaniesLink: (
                            <NavigationLink key="myCompaniesLink" to={appRoute.myCompanies.path}>
                                <Locale stringKey="CATEGORY_NAME__MY_COMPANIES" />
                            </NavigationLink>
                        ),
                    }}
                />
            </PageCard>
        </>
    );
}
